import { WebWorkerMessageHandler } from '../../../../core/web-workers/web-worker-message-handler.model';
import { Store } from '@ngrx/store';
import * as cameraActions from 'src/app/modules/cop/store/cameras/cameras.actions';
import { LoggerService } from 'src/app/modules/core/services/logger/logger.service';
import { Logger, LogLevel } from 'src/app/modules/core/services/logger/logger.model';

export class ProcessVmsDataChangeEventHandler implements WebWorkerMessageHandler {
  private logger: Logger;

  public constructor(private store$: Store, private loggerService: LoggerService) {
    this.logger = this.loggerService.getLogger('WebworkerClient.ProcessVmsDataChangeEventHandler');
  }

  processMessage(payload: any): void {
    const stopWatch = this.logger.startStopwatch(LogLevel.Info, 'ProcessVmsDataChangeEventHandler.processMessage()');

    if (!!payload) {
      setTimeout(() => {
        this.store$.dispatch(cameraActions.loadVmsCameraMedia({ integrationKey: payload.integrationKey, cameras: payload.cameras }));
      }, 1);
    }

    stopWatch.stop();
  }
}
